const Footer = () => {
  return (
    <div className="flex flex-col my-5 py-5 text-white">
      <div className="text-xs md:text-sm text-center">Created by</div>
      <div className="text-xs md:text-sm flex justify-center items-center gap-x-1">
        <a
          href="https://"
          rel="noopener noreferrer"
          target="_blank"
        >
          {" "}
          <span className="link-underline link-underline-black">Oscar</span>
        </a>
    </div>
    </div>
  );
};

export default Footer;
